import { https } from "../http";
import store from "../store";
import {
  setAddNoteLoading,
  setAllNotesTypes,
  setBillingNotes,
  setFieldTypes,
  setLoading,
  setLoadingNote_Report,
  setLoadingNote_Types,
  setNotePageLoaging,
  setNoteTypes,
  setNote_Report,
  setNotes,
  setNotesAgainstType,
  setSingleNote,
  setDrafts,
  setDraftsLoading,
  bumpDraftSaved,
} from "../store/reducers/note";
import { showError } from "../utils/index";
import swal from "sweetalert";
import {  getPlans } from "./supportplan";
import { setDashboardNotes } from "../store/reducers/dashboard";
import { getTodaysNotes } from "./dashboard";
import { getSkaiTokenUsage } from "./skaiTokens";

// GET
const getFieldTypes = async (showLoading = true) => {
  try {
    let response = await https().get("/field-type");

    if (response?.status === 200) {
      store.dispatch(setFieldTypes(response?.data));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const getNoteTypes = async (page, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/ntype/${page}`);

    if (response?.status === 200) {
      store.dispatch(setLoading(false));
      store.dispatch(setNoteTypes(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getAllNoteTypes = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/ntype/all`);

    if (response?.status === 200) {
      store.dispatch(setLoading(false));
      store.dispatch(setAllNotesTypes(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getNotes = async (
  page,
  userId,
  showLoading = true,
  dateRange,
  sortField = "createdAt",
  sortOrder = "descending",
  searchStr,
  filters = {}
) => {
  try {
    if (showLoading) store.dispatch(setNotePageLoaging(true));
    ///mar/get?client=${userId}&page=${page}
    let clientParam = filters.client || (userId ? userId : undefined);
    let queryStr = `?page=${page}&client=${clientParam}&sortField=${sortField ? sortField : undefined}&sortOrder=${
      sortOrder ? sortOrder : undefined
    }`;
    if (dateRange) {
      queryStr = queryStr + `&dateRange=${dateRange}`;
    }
    if (searchStr) {
      queryStr = queryStr + `&search=${searchStr}`;
    }
    if (filters.noteTypeFilter) queryStr += `&noteType=${filters.noteTypeFilter}`;
    if (filters.facility) queryStr += `&facility=${filters.facility}`;
    if (filters.createdBy) queryStr += `&createdBy=${filters.createdBy}`;
    let response = await https().get(`/note${queryStr}`);
    if (response?.status === 200) {
      store.dispatch(setNotes(response?.data));
      store.dispatch(setNotePageLoaging(false));
    }
  } catch (error) {
    store.dispatch(setNotePageLoaging(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getSingleNote = async (noteId, userId, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    store.dispatch(setSingleNote(null));
    let response = await https().get(`/note/${noteId}`);

    if (response?.status === 200) {
      store.dispatch(setSingleNote(response?.data?.note));
      return response?.data?.note;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getNotesByReport = async (id) => {
  try {
    store.dispatch(setLoadingNote_Types(true));
    let response = await https().post(`/note/getNotesByReport`, {
      reportId: id,
    });

    if (response?.status === 200) {
      store.dispatch(setNotesAgainstType(response?.data));
      store.dispatch(setLoadingNote_Types(false));
    }
  } catch (error) {
    store.dispatch(setLoadingNote_Types(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getNotesReport = async (payload, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoadingNote_Report(true));
    let response = await https().post("/note/notesReport", payload);

    if (response?.status === 200) {
      store.dispatch(setNote_Report(response?.data?.data));
      store.dispatch(setLoadingNote_Report(false));
      return response?.data?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingNote_Report(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// get Billing Notes

const getBillingNotes = async (dateRange) => {
  try {
    let queryStr = "";

    if (dateRange && dateRange.start_date && dateRange.end_date) {
      queryStr = `?start_date=${dateRange.start_date}&end_date=${dateRange.end_date}`;
    }

    let response = await https().get(`/note/get-billing-notes${queryStr}`);

    if (response?.status === 200) {
      store.dispatch(setBillingNotes(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// POST

const createNoteType = async (data) => {
  try {
    store.dispatch(setAddNoteLoading(true));
    let response = await https().post("/ntype", data);

    if (response?.status === 200) {
      getNoteTypes();
    }
  } catch (error) {
    store.dispatch(setAddNoteLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const createNote = async (data, callback, refreshUserId = data?.userId) => {
  try {
    store.dispatch(setAddNoteLoading(true));
    let response = await https().post("/note", data);

    if (response?.status === 200) {
      getNotes(1, refreshUserId || null, false);
      // await swal({
      //   title: `Note Added`,
      //   text: "Note has been added successfully",
      //   icon: "success",
      //   dangerMode: false,
      //   buttons: ["Cancel", "OK"],
      // });
      callback?.();
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    if (_error?.includes("duplicate") && _error?.includes("name"))
      showError("This name is already taken");
    else showError(_error, error?.response?.status);
    store.dispatch(setAddNoteLoading(false));
    // showError(error?.response?.data?.message, error?.response?.status)
    return false;
  }
};

// PUT
const editNoteType = async (data, callback) => {
  try {
    store.dispatch(setLoading(true));

    let response = await https().put("/ntype", data);

    if (response?.status === 200) {
      getNoteTypes(1);

      callback?.();
    }
  } catch (error) {
    let _error = error?.response?.data?.message;

    if (_error?.includes("duplicate") && _error?.includes("name"))
      showError("Note Name already exists");
    else showError(_error, error?.response?.status);
    store.dispatch(setLoading(false));
    return false;
    // showError(error?.response?.data?.message, error?.response?.status)
  }
};

// NOTE APPROVAL
const noteTypeApproval = async (data, callback) => {
  try {
    // store.dispatch(setLoading(true));
    let response = await https().put("/ntype/noteTypesApproval", data);
    if (response?.status === 200) {
      // getNoteTypes(1);
      callback?.();
    }
    return response;
  } catch (error) {
    let _error = error?.response?.data?.message;

    if (_error?.includes("duplicate") && _error?.includes("name"))
      showError("Note Name already exists");
    else showError(_error, error?.response?.status);
    // store.dispatch(setLoading(false));
    return false;
    // showError(error?.response?.data?.message, error?.response?.status)
  }
};

const editNote = async (
  data,
  showLoading = true,
  callback = null,
  sortField,
  sortOrder,
  setEditModal
) => {
  try {
    store.dispatch(setAddNoteLoading(true));
    store.dispatch(setNotePageLoaging(true));

    let response = await https().put(`/note`, data);

    if (response?.status === 200) {
      data?.userId
        ? getNotes(1, data?.userId, false, sortField, sortOrder)
        : getNotes(1, null, false, null, sortField, sortOrder);
      data?.userId
        ? getPlans(1, data?.userId, null, false)
        : getPlans(1, null, null, false);

      // getNotes();
      // await swal({
      //   title: `Note Edited`,
      //   text: "Note has been edited successfully",
      //   icon: "success",
      //   dangerMode: false,
      //   buttons: ["Cancel", "OK"],
      // });
      setEditModal(true);
      callback?.();
      return;
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    if (_error?.includes("duplicate") && _error?.includes("name"))
      showError("This name is already taken");
    else showError(_error, error?.response?.status);
    store.dispatch(setAddNoteLoading(false));
    store.dispatch(setNotePageLoaging(false));

    // showError(error?.response?.data?.message, error?.response?.status)
    return false;
  }
};

// Note Status Update
const updateNoteStatus = async (data) => {
  try {
    store.dispatch(setAddNoteLoading(true));
    let response = await https().put(`/note/note-status`, data);

    if (response?.status === 200) {
      await swal({
        title: response?.data?.message?.toUpperCase(),
        text: `${response?.data?.message} successfully!`,
        icon: "success",
        dangerMode: false,
        buttons: ["Cancel", "OK"],
      });
      // callback?.();
    }
    return response;
  } catch (error) {
    let _error = error?.response?.data?.message;
    await swal({
      title: `Note Status Update Failed`,
      text: _error,
      icon: "error",
      dangerMode: false,
      buttons: ["Cancel", "OK"],
    });
    store.dispatch(setAddNoteLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// DELETE
const remoteNoteType = async (id, callback) => {
  try {
    store.dispatch(setAddNoteLoading(true));
    let response = await https().delete(`/ntype?id=${id}`);

    if (response?.status === 200) {
      getNoteTypes(false);
      callback?.();
    }
  } catch (error) {
    store.dispatch(setAddNoteLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const removeNote = async (
  data,
  userId,
  callback,
  sortField,
  sortOrder,
  isDashboradMode
) => {
  try {
    store.dispatch(setNotePageLoaging(true));
    if (isDashboradMode) {
      store.dispatch(setDashboardNotes(true));
    }
    let response = await https().delete(`/note/${data?.id}`);

    if (response?.status === 200) {
      if (isDashboradMode) {
        getTodaysNotes("", false);
      } else {
        userId
          ? getNotes(1, userId, false, null, sortField, sortOrder)
          : getNotes(1, null, false, null, sortField, sortOrder);
      }
      callback?.();
    }
  } catch (error) {
    store.dispatch(setNotePageLoaging(false));
    if (isDashboradMode) {
      store.dispatch(setDashboardNotes(false));
    }
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const generateAiNote = async (prompt, profileId, provider = "openai") => {
  try {
    const response = await https().post("/note/ai-response", {
      prompt,
      provider,
    });
    getSkaiTokenUsage(profileId);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const generateBothAiNotes = async (prompt, profileId) => {
  try {
    const response = await https().post("/note/ai-response", {
      prompt,
      provider: "both",
    });
    getSkaiTokenUsage(profileId);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//   export const getSkaiTokenUsage = async (id, showLoading = true) => {
//   try {
//     if (showLoading) store.dispatch(setLoading(true));

//     const response = await https().get(`/skai/tokens-usage/${id}`);

//     if (response?.status === 200) {
//       store.dispatch(setSkaiTokenUsage(response?.data));
//     }

//   } catch (error) {
//     showError(error?.response?.data?.message, error?.response?.status);
//   } finally {
//     if (showLoading) store.dispatch(setLoading(false));
//   }
// };

const transcribeAudio = async (audioBlob) => {
  const formData = new FormData();
  formData.append("file", audioBlob, "recording.webm");

  try {
    const response = await https().post("/note/voice-transcribe", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.transcript;
  } catch (error) {
    throw error;
  }
};

// ── Note Drafts (auto-save + drafts list) ──
const saveNoteDraft = async (data) => {
  try {
    const response = await https().put("/note/draft", data);
    if (response?.status === 200) {
      store.dispatch(bumpDraftSaved());
      return true;
    }
    return false;
  } catch {
    return false; // Silent failure — don't interrupt the user
  }
};

const getNoteDraft = async (noteTypeId, clientId, facilityId) => {
  try {
    const url = facilityId ? `/note/draft/${noteTypeId}/${clientId}/${facilityId}` : `/note/draft/${noteTypeId}/${clientId}`;
    const response = await https().get(url);
    return response?.data?.draft || null;
  } catch {
    return null;
  }
};

const deleteNoteDraft = async (noteTypeId, clientId) => {
  try {
    await https().delete(`/note/draft/${noteTypeId}/${clientId}`);
  } catch {
    // Silent failure
  }
};

const logAiSuggestionEvent = async (data) => {
  try {
    await https().post("/analytics/ai-suggestion-event", data);
  } catch {
    // fire-and-forget — never block the user
  }
};

const getAllDrafts = async (dispatch, clientId = null, showLoading = true) => {
  if (showLoading) dispatch(setDraftsLoading(true));
  try {
    const url = clientId ? `/note/drafts?clientId=${clientId}` : "/note/drafts";
    const res = await https().get(url);
    dispatch(setDrafts(res?.data?.drafts || []));
  } catch (err) {
    showError(err?.response?.data?.message, err?.response?.status);
    if (showLoading) dispatch(setDraftsLoading(false));
  }
};

export {
  createNote,
  createNoteType,
  editNote,
  editNoteType,
  getAllNoteTypes,
  getFieldTypes,
  getNoteTypes,
  getNotes,
  getSingleNote,
  getNotesByReport,
  remoteNoteType,
  removeNote,
  noteTypeApproval,
  updateNoteStatus,
  getBillingNotes,
  generateAiNote,
  generateBothAiNotes,
  transcribeAudio,
  getNotesReport,
  saveNoteDraft,
  getNoteDraft,
  deleteNoteDraft,
  getAllDrafts,
  logAiSuggestionEvent,
};
